import {
  Card, CardContent, Container, Divider, Typography, BottomNavigation, BottomNavigationAction, Paper, Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  DialogActions
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PullToRefresh } from 'react-js-pull-to-refresh';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import {
  getClosedJobsRequest, resetDefects, resetLabours, resetMaterials
} from '../../store/actions';
import AtananIsler from './AssignedJob';
import Header from './Header';
import BottomRouters from 'src/components/BottomRouters';
import { removeBaslandiJob } from 'src/utils/storage/StartWorkOrder';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1)
  },
  statistics: {
    marginTop: theme.spacing(3)
  },
  AtananIsler: {
    marginTop: theme.spacing(1)
  },
  ClosedJob: {
    marginTop: theme.spacing(1)
  },
  projects: {
    marginTop: theme.spacing(6)
  },
  todos: {
    marginTop: theme.spacing(6)
  },
  content: {
    padding: 0,
    minHeight: 430,
  },
}));


const ClosedJob = (props) => {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const {
    getClosedJobsRequest, resetDefects, resetLabours, resetMaterials, closedJobs
  } = props;


  useEffect(() => {
    getClosedJobsRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
    // eslint-disable-next-line
  }, []);

  const AtananIslerData = closedJobs.tasks;
  const jobs = (AtananIslerData != undefined && AtananIslerData !== '') ? AtananIslerData : [];

  const handleRefresh = () => {
    getClosedJobsRequest();
    resetLabours();
    resetDefects();
    resetMaterials();
    removeBaslandiJob();
  };

  const onRefresh = () => new Promise((resolve) => {
    setTimeout(resolve, 150);
    getClosedJobsRequest();
  });

  return (
    <Page className={classes.root} title={'Sirius Tech'}>
      <Container maxWidth="lg">
        <Header AtananIsler={jobs} title={t('lblHistoricalJobsTitle')} />
        <PullToRefresh
          pullDownContent={<CircularProgress status="loading" style={{ marginLeft: '45%' }} />}
          releaseContent={<CircularProgress status="loading" style={{ marginLeft: '45%' }} />}
          refreshContent={<CircularProgress status="loading" style={{ marginLeft: '45%' }} />}
          pullDownThreshold={100}
          onRefresh={onRefresh}
          triggerHeight={500}
          startInvisible
        >

          <div style={{ minHeight: 400, textAlign: 'center' }}>
            <AtananIsler className={classes.AtananIsler} AtananIsler={jobs} handleRefresh={handleRefresh} />
          </div>
        </PullToRefresh>
        <br />
        <br />
        <br />
        <br />
        <br />
        <BottomRouters />
      </Container>
    </Page>
  );
};
export default connect(
  (state) => ({ closedJobs: state.tasks1 }),
  {
    getClosedJobsRequest, resetDefects, resetLabours, resetMaterials
  }
)(ClosedJob);
